module.exports = __webpack_public_path__ + "img/routes_create_light.87f1dc3a.gif";